export default __webpack_public_path__ + "static/media/Clothing.1dd2d670.svg";